import {dbPost} from 'utils/ajaxUtils';

export const login = (email, password) => dbPost("login", {
    email: email,
    password: password
});

export const logout = () => dbPost("logout", {});

export const resetPassword = (email, language) => dbPost("forgotpw" , {
    email: email,
    language: language
});



// WEBPACK FOOTER //
// ./public/api/user.js